// Utils
import { getDiscount } from "./getDiscount"

export function getAmount(
  amount: number,
  isSpendMoney: boolean,
  rate: number,
  taxInclusive: boolean
): number {
  if (taxInclusive) {
    if (isSpendMoney) {
      return Math.round(amount - getDiscount(amount, rate))
    } else {
      return Math.round(amount * (100 - rate) / 100)
    }
  }

  return amount
}